import { DocumentTemplateFilterOptions } from '../../enums/filters-and-searchs/document.template.filter.options';

export const DocumentTemplateFilterOptionsDetails = new Map<number, string>([
    [DocumentTemplateFilterOptions.None, 'None'],
    [DocumentTemplateFilterOptions.Deleted, 'Deleted document template']
]);